import theme from '../../themes/theme';
const { notificationTypes } = theme;

const iconsClass = {
  display: 'flex',
  alignSelf: 'center',
  alignItems: 'center',
  borderRadius: '50% 50%',
  height: '3em',
  width: '3em',
};

export default {
  itemActions: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconDiv: {
    padding: '0 1.2em',
  },
  phoneIcon: {
    ...iconsClass,
    border: `1px solid ${notificationTypes.calendar}`,
  },

  naviIcon: {
    ...iconsClass,
    border: `1px solid ${notificationTypes.navigation}`,
  },
};
